// Backend-Vertragstypen (nur die Felder, die die sichere View liefert).
// Quelle: public.merchant_terminal_orders. KEINE Kunden-PII, kein
// Handover-Code — diese sind serverseitig gar nicht Teil der View.

export type OrderStatus =
  | "created"
  | "awaiting_merchant"
  | "merchant_accepted"
  | "merchant_rejected"
  | "awaiting_assignment"
  | "rider_assigned"
  | "rider_accepted"
  | "en_route_to_shop"
  | "at_shop"
  | "picked_up"
  | "en_route_to_point"
  | "at_point"
  | "handed_over"
  | "not_collected"
  | "cancelled"
  | "incident";

export type PrepStatus = "none" | "preparing" | "ready";

export interface OrderItem {
  name?: string;
  quantity?: number;
}

export interface TerminalOrder {
  order_id: string;
  merchant_id: string;
  order_number: string;
  customer_display: string; // = Bestellnummer (keine PII)
  created_at: string;
  requested_pickup_at: string | null;
  status: OrderStatus;
  prep_status: PrepStatus;
  prep_minutes: number | null;
  estimated_ready_at: string | null;
  customer_note: string | null;
  cancelled_reason: string | null;
  shoppi_point_name: string | null;
  shoppi_point_code: string | null;
  shoppi_point_address: string | null;
  items: OrderItem[] | null;
}

export type Role = "customer" | "merchant" | "rider" | "admin";

export interface Profile {
  id: string;
  role: Role;
  is_active: boolean;
  full_name: string | null;
}

// Strukturierte Ablehnungsgründe — EXAKT die Backend-Whitelist von
// merchant_reject_order (keine clientseitig erfundenen Werte).
export const REJECT_REASONS: { code: string; label: string }[] = [
  { code: "ITEM_UNAVAILABLE", label: "Artikel nicht verfügbar" },
  { code: "TOO_BUSY", label: "Zu ausgelastet" },
  { code: "CLOSING", label: "Schließt / geschlossen" },
  { code: "TECHNICAL_PROBLEM", label: "Technisches Problem" },
  { code: "OTHER", label: "Anderer Grund" },
];

// Prep-Grenzen entsprechen dem Backend (merchant_min/max_prep_minutes).
export const PREP_MIN_MINUTES = 5;
export const PREP_MAX_MINUTES = 180;
export const PREP_QUICK_OPTIONS = [10, 15, 20, 30, 45, 60];

export function isAwaitingMerchant(o: TerminalOrder): boolean {
  return o.status === "awaiting_merchant";
}
